export const profileSyncEducation = {
    templateUrl: Evisors.config.cdnRootWhitelabel + 'asset/partials/user/components/profileSyncEducation.html',
    bindings: {
        diff: '<',
        onApply: '&',
        onCancel: '&',
    },
};
